module.exports = __webpack_public_path__ + "static/img/Mobile-Devices-Green-Hue.ff50c79e.jpg";